module.exports = __webpack_public_path__ + "static/img/partner-logo-1.195e7186.png";